import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container space">
      <div >

        {/* Main Heading */}
        <h1 className="text-center fw-bold mb-5">Privacy Policy</h1>

        {/* Intro */}
        <p className="mb-4 text-muted">
          Welcome to <strong>AEPSPay</strong> ("we", "our", "us"). Your privacy is
          important to us. This Privacy Policy explains how we collect, use,
          store, and protect your information when you use our website,
          software, APIs, and services including Aadhaar Enabled Payment System
          (AEPS), Cash Withdrawal, Cash Deposit, Mini Statement, Balance
          Enquiry, Domestic Money Transfer (DMT), Utility Bill Payment, AEPS
          Software, and AEPS API Integration. By using AEPSPay, you agree to the
          practices described in this Privacy Policy.
        </p>

        {/* 1 */}
        <h4 className="fw-bold mt-4">1. Information We Collect</h4>
        <p className="mb-2 text-muted">
          We may collect the following types of information when you use our
          services:
        </p>

        <h6 className="fw-bold mt-3">Personal Information</h6>
        <ul className="mb-3">
          <li>Name</li>
          <li>Mobile number</li>
          <li>Email address</li>
          <li>Address</li>
          <li>Date of birth</li>
          <li>Identity verification details</li>
        </ul>

        <h6 className="fw-bold mt-3">Aadhaar Related Information</h6>
        <ul className="mb-3">
          <li>Aadhaar number (masked or tokenized where required)</li>
          <li>
            Biometric authentication data (processed through authorized service
            providers)
          </li>
          <li>Transaction authentication details</li>
        </ul>
        <p className="text-muted">We do not store biometric data on our servers.</p>

        <h6 className="fw-bold mt-3">Financial & Transaction Information</h6>
        <ul className="mb-3">
          <li>Bank account details (where required for services)</li>
          <li>Transaction history</li>
          <li>Payment records</li>
          <li>Wallet balances</li>
        </ul>

        <h6 className="fw-bold mt-3">Device & Technical Information</h6>
        <ul className="mb-3">
          <li>IP address</li>
          <li>Browser type</li>
          <li>Device information</li>
          <li>Log files</li>
          <li>Cookies and usage data</li>
        </ul>

        {/* 2 */}
        <h4 className="fw-bold mt-4">2. How We Use Your Information</h4>
        <ul className="mb-3">
          <li>To provide AEPS services such as cash withdrawal, deposit, balance enquiry, and mini statement</li>
          <li>To process Domestic Money Transfer (DMT)</li>
          <li>To process utility bill payments</li>
          <li>To enable API integration and software functionality</li>
          <li>To verify user identity</li>
          <li>To prevent fraud and unauthorized transactions</li>
          <li>To improve our services and platform</li>
          <li>To comply with legal and regulatory requirements</li>
        </ul>

        {/* 3 */}
        <h4 className="fw-bold mt-4">3. Aadhaar Data Protection</h4>
        <ul className="mb-3">
          <li>Authentication is performed through authorized gateways and partners compliant with UIDAI.</li>
          <li>AEPS transactions follow guidelines issued by NPCI.</li>
          <li>We do not store biometric authentication data.</li>
          <li>Aadhaar data is encrypted and transmitted securely.</li>
        </ul>

        {/* 4 */}
        <h4 className="fw-bold mt-4">4. Sharing of Information</h4>
        <p className="text-muted">
          We do not sell or rent your personal information. However, we may
          share information with:
        </p>
        <ul className="mb-3">
          <li>Banking partners</li>
          <li>Payment gateways</li>
          <li>Government authorities when required by law</li>
          <li>Regulatory bodies such as the Reserve Bank of India</li>
          <li>Service providers that help operate our platform</li>
        </ul>

        {/* 5 */}
        <h4 className="fw-bold mt-4">5. Data Security</h4>
        <p className="text-muted">
          We implement industry-standard security measures including SSL
          encryption, secure servers, access control, and fraud monitoring
          systems. However, no method of transmission over the internet is
          completely secure.
        </p>

        {/* 6 */}
        <h4 className="fw-bold mt-4">6. Cookies and Tracking Technologies</h4>
        <p className="text-muted">
          Our website may use cookies to improve performance, remember user
          preferences, and analyze traffic. Users may disable cookies in their
          browser settings.
        </p>

        {/* 7 */}
        <h4 className="fw-bold mt-4">7. Data Retention</h4>
        <p className="text-muted">
          We retain your information as long as necessary to provide services,
          comply with legal obligations, resolve disputes, and enforce
          agreements.
        </p>

        {/* 8 */}
        <h4 className="fw-bold mt-4">8. User Rights</h4>
        <ul className="mb-3">
          <li>Access personal data</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion where applicable</li>
          <li>Withdraw consent for data processing</li>
        </ul>

        {/* 9 */}
        <h4 className="fw-bold mt-4">9. Third-Party Links</h4>
        <p className="text-muted">
          We are not responsible for privacy practices of third-party websites.
        </p>

        {/* 10 */}
        <h4 className="fw-bold mt-4">10. Children's Privacy</h4>
        <p className="text-muted">
          Our services are not intended for individuals under the age of 18.
        </p>

        {/* 11 */}
        <h4 className="fw-bold mt-4">11. Changes to This Privacy Policy</h4>
        <p className="text-muted">
          We may update this Privacy Policy periodically. Updates will be posted
          on this page.
        </p>

        {/* Contact */}
        <h4 className="fw-bold mt-4">12. Contact Us</h4>
        <p>
          If you have any questions about this Privacy Policy please{" "}
          <a href="/contact" className="fw-semibold text-primary">
            Contact Us
          </a>
          .
        </p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;